import { PaymentOffsetInterface } from "./PaymentOffsetInterface";

import { WeekBefore } from "./Offsets/WeekBefore";
import { Minus3Day } from "./Offsets/Minus3Day";
import { Minus2Day } from "./Offsets/Minus2Day";
import { Minus1Day } from "./Offsets/Minus1Day";
import { FirstDayOfPeriod } from "./Offsets/FirstDayOfPeriod";
import { Plus1Day } from "./Offsets/Plus1Day";
import { Plus2Day } from "./Offsets/Plus2Day";
import { Plus3Day } from "./Offsets/Plus3Day";
import { WeekAfter } from "./Offsets/WeekAfter";

class PaymentOffsetContainer {

  private offsets = [
    WeekBefore,
    Minus3Day,
    Minus2Day,
    Minus1Day,
    FirstDayOfPeriod,
    Plus1Day,
    Plus2Day,
    Plus3Day,
    WeekAfter
  ];

  private instances = [
    new WeekBefore(),
    new Minus3Day(),
    new Minus2Day(),
    new Minus1Day(),
    new FirstDayOfPeriod(),
    new Plus1Day(),
    new Plus2Day(),
    new Plus3Day(),
    new WeekAfter()
  ];

  public getOffsets() {
    return this.offsets;
  }

  public getInstances() {
    return this.instances;
  }

  public pickFromId(paymentOffset: number): PaymentOffsetInterface {
    const index = this.getInstances().findIndex(offset => offset.getValue() === paymentOffset);
    return this.getInstances()[index];
  }

}

export default new PaymentOffsetContainer();
